import { Alert, Col, Form, Input, Row } from "antd";
import { registerFormRules as rules } from "../../utils/form-rules";
import { colLayout } from "../../utils/utils";

const passwordLayout = { xs: 24, sm: 12, md: 12, lg: 8 }


const Password = () => {
    return (
        <>
            <Row gutter={10}>
                <Col {...colLayout} md={16} xl={16}>

                    <div style={{ marginBottom: "20px" }}>
                        <Alert message="La sig contraseña será utilizada luego en el sistema de Gestión de Socios" type="info" showIcon />
                        {/* <Tag icon={<InfoCircleOutlined />} color="#2db7f5" style={{ whiteSpace: "inherit" }}>La sig contraseña será utilizada luego en el sistema de Gestión de Socios</Tag> */}
                    </div>
                </Col>
            </Row>

            <Row gutter={10}>
                <Col {...passwordLayout}>
                    <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={[...rules.password]}
                    >
                        <Input.Password />
                    </Form.Item>
                </Col>
                <Col {...passwordLayout}>
                    <Form.Item
                        label="Repetir Contraseña"
                        name="confirmPassword"
                        rules={[...rules.confirmPassword]}
                    >
                        <Input.Password />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
}

export default Password;